import { storeToRefs } from "pinia";

export const useAllParametrics = () => {
	const { getAllParametrics } = useNorcePwa();
	const { allParametrics } = storeToRefs(useNorceStore());

	const { locale } = useI18n();

	const fetchAllParametrics = async () => {
		let parametrics =
			allParametrics.value[locale.value as keyof typeof allParametrics.value];
		if (!parametrics?.length) {
			parametrics = await getAllParametrics({
				...useNorceStore().storeContext
			});
			useNorceStore().addAllParametrics({ [locale.value]: parametrics });
		}

		return parametrics;
	};

	return { fetchAllParametrics };
};
